<template>
  <div class="sidebar">
    <div class="filters">
      <search-bar v-if="includeSearchField" class="search-bar"
                  :initial-query="locationQuery"
                  @search="applyLocationFilter">
        <template #search-button>
          <button type="submit" class="btn search-button" :title="i18n.t('search')">
            <i class="icon-search" />
          </button>
        </template>
      </search-bar>
      <TypeFilter v-if="showTypeFilter"
                  :initial-types="typeQuery" class="type-filter"
                  @change="applyTypeFilter" />
      <advanced-filters-section v-if="showAdvancedFilters"
                                :allowed-filter-keys="allowedAdvancedFilters"
                                @change="applyAdvancedFilterChange" />
    </div>
    <location-list :class="[{translucent: isLoadingList}, 'location-list']"
                   :locations="detailedLocations"
                   @paginate="onPaginate" />
    <slot name="sidebar-footer" />
  </div>
</template>

<script>
import AdvancedFiltersSection from './advanced-filters-section'
import LocationList from './location-list'
import { mapState } from 'vuex'
import SearchBar from './search-bar'
import TypeFilter from './type-filter'
import { localListMixin } from './local-list-mixin'

export default {
  components: {
    AdvancedFiltersSection,
    LocationList,
    SearchBar,
    TypeFilter },

  mixins: [ localListMixin ],

  props: {
    includeSearchField: {
      type: Boolean,
      required: false,
      default: true
    }
  },

  computed: {
    ...mapState(['isLoadingList'])
  }

}
</script>

<style lang="scss" scoped>
@use "~common_styles/breakpoints" as breakpoints;
@use "~friendship_styles/colors" as colors;

.sidebar {
  background-color: colors.$widget-background-light-gray;
}

.filters {
  padding: 3px 20px;
}

.search-bar {
  margin: 20px 0 15px 0;
  color: white;

  ::v-deep(input) {
    border-radius: 0;
  }
}

.search-button {
  border-radius: 0;
  background-color: black;
  color: white;
}

.type-filter {
  margin-top: 15px;
}

.translucent {
  opacity: colors.$loading_opacity;
}

.location-list {
  margin: 15px 20px;

  > ::v-deep(ul > li:not(:last-child)) {
    margin-bottom: 20px;
  }
}

@include breakpoints.screen-md-up {
  .sidebar {
    overflow-y: auto;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
  }

  ::v-deep(.footer) {
    & > .container {
      width: initial;
    }
  }
}

@include breakpoints.screen-mobile-only {
  ::v-deep(.content) {
    position: relative;
  }
}
</style>
